/**
 * Cookie management utility for the application
 * Provides methods to get, set, and check cookie consent preferences
 */

import { getCookiePreferences as readCookiePreferences, isCookieAccepted as checkCookieAccepted } from './cookieConsent';

// Default cookie preferences configuration
const defaultPreferences = {
  essential: true,
  analytics: false,
  functional: false,
  targeting: false
};

/**
 * Get user's cookie preferences
 * @returns {Object} Cookie preferences
 */
export const getCookiePreferences = () => readCookiePreferences();

/**
 * Save user's cookie preferences
 * @param {Object} preferences - User's cookie preferences
 */
export const saveCookiePreferences = (preferences) => {
  try {
    localStorage.setItem('cookieConsent', 'true');
    localStorage.setItem('cookiePreferences', JSON.stringify({
      ...preferences,
      essential: true // Essential cookies are always required
    }));
    
    // TrackingScripts listens to this event and reloads scripts
    window.dispatchEvent(new Event('cookiePreferencesChanged'));
  } catch (error) {
    console.error('Error saving cookie preferences:', error);
  }
};

/**
 * Check if a specific cookie type is accepted
 * @param {string} type - Cookie type ('essential', 'analytics', 'functional', 'targeting')
 * @returns {boolean} Whether the cookie type is accepted
 */
export const isCookieAccepted = (type) => checkCookieAccepted(type);

/**
 * Check if user has given cookie consent
 * @returns {boolean} Whether the user has consented to cookies
 */
export const hasConsent = () => {
  return localStorage.getItem('cookieConsent') === 'true';
};

/**
 * Reset cookie preferences to default
 */
export const resetCookiePreferences = () => {
  localStorage.removeItem('cookieConsent');
  localStorage.removeItem('cookiePreferences');
  
  window.dispatchEvent(new Event('cookiePreferencesChanged'));
};

const cookieManager = {
  getCookiePreferences,
  saveCookiePreferences,
  isCookieAccepted,
  hasConsent,
  resetCookiePreferences,
  defaultPreferences,
};
export default cookieManager;
